var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Dialog from '@material-ui/core/Dialog';
var SuccessDialog = /** @class */ (function (_super) {
    __extends(SuccessDialog, _super);
    function SuccessDialog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SuccessDialog.prototype.render = function () {
        var _a = this.props, dialogContent = _a.dialogContent, tubeColor = _a.tubeColor, header = _a.header, other = __rest(_a, ["dialogContent", "tubeColor", "header"]);
        return (React.createElement(Dialog, __assign({ maxWidth: "md", "aria-labelledby": "confirm-dialog" }, other),
            React.createElement(DialogTitle, { id: "confirm-dialog" },
                React.createElement("span", { style: { color: tubeColor } }, header)),
            React.createElement(DialogContent, null,
                React.createElement("p", null,
                    dialogContent,
                    "."))));
    };
    return SuccessDialog;
}(React.PureComponent));
export { SuccessDialog };



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/SuccessDialog.tsx
// module id = 465
// module chunks = 81